export default __webpack_public_path__ + "static/media/api-svg.02fb8bd5.png";